<template>
    <div ref="element"></div>
</template>


<script setup lang="ts">
import { useYandexPayStore } from '~/store/yandexPayStore';
import type { YaPaySdk } from '~/types/yaPay';

declare var YaPay: YaPaySdk.YaPay | undefined;

const props = defineProps<{
    price: number;
    size?: YaPaySdk.BadgeSize;
    id?: number;
}>();

const elementRef = useTemplateRef('element');

onMounted(async () => {
    await useYandexPayStore().loadYandexScript();
    createBadge();
});

onBeforeUnmount(() => {
    destroyBadge();
})

async function createBadge() {
    if (!YaPay || !elementRef.value) {
        return;
    }

    await YaPay.mountBadge(
        elementRef.value,
        {
            type: 'bnpl',
            amount: props.price.toFixed(2),
            size: props.size ?? 's',
            variant: 'simple',
            productId: props.id?.toString(),
            color: 'transparent',
            merchantId: '8480cbf0-58df-4fe3-8b17-9cb8b9f9cb26',
        }
    );
}

function destroyBadge() {
    // YaPay.un
}

</script>
